<script setup>
import { computed, onMounted, ref } from 'vue';
import apiManager from '@/api';
import SMEForm from './SMEForm.vue';
import EventSection from './EventSection.vue';

const props = defineProps({
  event: Object,
  statuses: Object,
  authEmail: String, // for initial flow prepopulate
  authVerification: String, // for initial flow prepopulate
  session: Object, // for reschedule prepopulate
  serverErrorMessage: String,
});

const emit = defineEmits(['schedule']);
const prepopulate = ref();

const appointmentOptions = computed(() => {
  const startDays = props.event?.configSME?.appointments?.filter((x) => x.available > 0)
    .reduce((acc, x) => {
      const date = x.startDate.split('T')[0];
      return acc.some((y) => y.date === date)
        ? [...acc.filter((y) => y.date !== date), { date, times: [...acc.find((y) => y.date === date).times, { id: x.id, value: x.startDate.split('T')[1] }] }]
        : [...acc, { date, times: [{ id: x.id, value: x.startDate.split('T')[1] }] }];
    }, []);
  return [...new Set(startDays)];
});

const scheduleText = ref('Schedule an available time below to meet in-person at the event.');

onMounted(async () => { // prepopulate fields by existing session (reschedule) or by user
  if (props.authEmail && props.authVerification) {
    const { data } = await apiManager.user.getUser({
      email: props.authEmail,
      verificationCode: props.authVerification,
    });

    // arriving populated for some reason
    data.userProfileQuestion.interestedInFordProSolutions = '';

    prepopulate.value = { user: data };
  } else if (props.session) {
    prepopulate.value = props.session;
    scheduleText.value = 'Reschedule to an available time below to meet in-person at the event.';
  }
});

const schedule = (payload) => emit('schedule', payload);

const solutions = computed(() => props.event?.eventTypeSolutions);
</script>
<template>
  <div class="">
    <SME-form class="mx-auto"
      @submit="schedule"
      :appointmentOptions="appointmentOptions"
      :prepopulate="prepopulate"
      :statuses="statuses"
      :time-zone="event?.configSME?.timeZone || ''"
      :solutions="solutions"
      :sub-text="scheduleText"
      :server-error-message="serverErrorMessage"
    />
    <hr class="
      mx-auto
      max-w-[50rem]
      mb-[2.5rem] hidden tablet:block
    " />
    <event-section :event="event" />
  </div>
</template>
